import createIcon from '../../createIcon';

/**
 * @component @name CloudOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMzUgOS4wNEMxOC42NyA1LjU5IDE1LjY0IDMgMTIgM0MxMC41MiAzIDkuMTUgMy40MyA3Ljk5IDQuMTdMOS40NSA1LjYzQzEwLjIxIDUuMjMgMTEuMDggNSAxMiA1QzE1LjA0IDUgMTcuNSA3LjQ2IDE3LjUgMTAuNVYxMUgxOUMyMC42NiAxMSAyMiAxMi4zNCAyMiAxNEMyMiAxNS4xMyAyMS4zNiAxNi4xMSAyMC40NCAxNi42MkwyMS44OSAxOC4wN0MyMy4xNiAxNy4xNiAyNCAxNS42OCAyNCAxNEMyNCAxMS4zNiAyMS45NSA5LjIyIDE5LjM1IDkuMDRaTTMgNC4yN0w1Ljc1IDcuMDFDMi41NiA3LjE1IDAgOS43NyAwIDEzQzAgMTYuMzEgMi42OSAxOSA2IDE5SDE3LjczTDE5LjczIDIxTDIxIDE5LjczTDQuMjcgM0wzIDQuMjdaTTcuNzMgOUwxNS43MyAxN0g2QzMuNzkgMTcgMiAxNS4yMSAyIDEzQzIgMTAuNzkgMy43OSA5IDYgOUg3LjczWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CloudOff = createIcon('CloudOff', [
  [
    'path',
    {
      d: 'M19.35 9.04C18.67 5.59 15.64 3 12 3C10.52 3 9.15 3.43 7.99 4.17L9.45 5.63C10.21 5.23 11.08 5 12 5C15.04 5 17.5 7.46 17.5 10.5V11H19C20.66 11 22 12.34 22 14C22 15.13 21.36 16.11 20.44 16.62L21.89 18.07C23.16 17.16 24 15.68 24 14C24 11.36 21.95 9.22 19.35 9.04ZM3 4.27L5.75 7.01C2.56 7.15 0 9.77 0 13C0 16.31 2.69 19 6 19H17.73L19.73 21L21 19.73L4.27 3L3 4.27ZM7.73 9L15.73 17H6C3.79 17 2 15.21 2 13C2 10.79 3.79 9 6 9H7.73Z',
      key: 'mhcku4',
    },
  ],
]);

export default CloudOff;
